import React, { useEffect, useState } from "react";
import { Button, Select, Upload, Tooltip, Form, Divider, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getStates } from "../features/statecity/statecitySlice";
import { getBrands, getJobtrades } from "../features/brand/brandSlice";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { getUsers } from "../features/cutomers/customerSlice";
import { base_url } from "../utils/baseUrl";
import Papa from "papaparse";
import FileSaver from "file-saver";

const { Option } = Select;

const AddbulkSchool = () => {
  const statelistState = useSelector((state) => state.statecity.statelist);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [selectedState, setSelectedState] = useState("Select State");
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [districtOptions, setDistrictOptions] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    dispatch(getStates());
    dispatch(getJobtrades());
    dispatch(getBrands());
    dispatch(getUsers());
  }, [dispatch]);

  useEffect(() => {
    if (selectedState) {
      fetchDistricts(selectedState);
    }
  }, [selectedState]);

  const handleStateChange = (value) => {
    setSelectedState(value);
  };

  const handleDistrictChange = (value) => {
    setSelectedDistrict(value);
  };

  const fetchDistricts = async (stateCode) => {
    const vtfilterData = statelistState.filter(
      (distric) => distric.state === stateCode
    );
    setDistrictOptions(vtfilterData);
  };

  const downloadSchoolCsv = () => {
    FileSaver.saveAs(
      `${process.env.PUBLIC_URL}/sample_download/School_Sample.csv`,
      "School_Sample.csv"
    );
  };

  const handleFileUpload = (info) => {
    const file = info.file.originFileObj || info.file;

    if (!file) {
      toast.dismiss();
      toast.error("Failed to load file. Please try again.", {
        autoClose: 10000,
      });
      return;
    }

    if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
      toast.error("Please upload a CSV file.", { autoClose: 5000 });
      return;
    }

    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const headers = results.meta.fields;
        const requiredColumns = [
          "UDISE_Code",	
          "School_category",	
          "School_program",
          "school_name",
          "principal_name",
          "phone_no",
          "no_of_student",	
          "address",	
          "village",	
          "pincode",
          "trades",
          "classes",
          "jobroles"
        ];
        const missingColumns = requiredColumns.filter(
          (column) => !headers.includes(column)
        );

        if (missingColumns.length > 0) {
          toast.dismiss();
          toast.error(
            `Missing required columns: ${missingColumns.join(", ")}`,
            { autoClose: 10000 }
          );
          return;
        }

        const columns = headers.map((header) => ({
          title: header,
          dataIndex: header,
          key: header,
        }));

        setColumns(columns);
        setCsvData(results.data);
        toast.dismiss();
        toast.success("CSV file loaded successfully.", { autoClose: 4000 });
      },
      error: (error) => {
        toast.dismiss();
        toast.error("Failed to parse file.", { autoClose: 4000 });
      },
    });
  };

  const handleFileChange = (info) => {
    let newFileList = [...info.fileList];
    // Limit to one file
    newFileList = newFileList.slice(-1);

    setFileList(newFileList);

    if (newFileList.length > 0) {
      handleFileUpload(info);
    }
  };

  const handleFileRemove = () => {
    toast.dismiss();
    toast.error("Upload cleared.", { autoClose: 3000 });
    setCsvData([]);
    setColumns([]);
    setFileList([]);
  };

  const handleSubmit = () => {
    if (csvData.length === 0) {
      toast.dismiss();
      toast.error("Please upload the CSV File Before Submitting.", {
        autoClose: 5000,
      });
      return;
    }

    const userinfo = localStorage.getItem("user");
    if (!userinfo) {
      toast.dismiss();
      toast.error("User information not found. Please log in again.", {
        autoClose: 5000,
      });
      return;
    }

    const userData = JSON.parse(userinfo);
    const token = userData.token;

    if (!token) {
      toast.dismiss();
      toast.error("Token not found in local storage.", { autoClose: 5000 });
      return;
    }

    const data = {
      state_code: selectedState,
      csvData: csvData, // Send parsed CSV data
    };

    fetch(`${base_url}school/upload-school`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Log the Data ---", data);
        if (data.status === 'fail') {
          toast.error(data.message, {
            autoClose: 5000,
          });
        } else {
          toast.dismiss();
          toast.success("School Imported Successfully!", {
            autoClose: 5000,
          });
          // Handle any additional logic after successful upload, e.g., reset form
          form.resetFields();
          setCsvData([]);
          setColumns([]);
          setFileList([]);
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error("File upload failed.", { autoClose: 10000 });
      });
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Button
        type="link"
        onClick={() => navigate(-1)}
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "1rem",
          color: "#4a90e2",
        }}
      >
        <BiArrowBack /> Go Back
      </Button>

      <Divider />

      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h4 style={{ marginBottom: "20px", color: "#333333" }}>
          {" "}
          Bulk Schools Upload
        </h4>
        <div
          style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}
        >
          <Button
            type="primary"
            className="exportcsv"
            onClick={downloadSchoolCsv}
          >
            <DownloadOutlined /> Sample School
          </Button>
        </div>
        <Form form={form} layout="inline">
          
          <Form.Item
            name="state_name"
            rules={[{ required: true, message: "Please Select State!" }]}
          >
            <Select
              placeholder="Select State"
              onChange={handleStateChange}
              style={{ width: 150, marginRight: 5 }}
            >
              {statelistState.map((state) => (
                <Select.Option key={state.code} value={state.code}>
                  {state.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="file">
            <Tooltip title="Only .csv files are accepted">
              <Upload
                accept=".csv"
                fileList={fileList}
                beforeUpload={() => false}
                onChange={handleFileChange}
                onRemove={handleFileRemove}
                showUploadList={true}
              >
                <Button icon={<UploadOutlined />}>UPLOAD</Button>
              </Upload>
            </Tooltip>
          </Form.Item>
        </Form>

        <Button type="primary" style={{ width: 100, marginTop: 20 }} onClick={handleSubmit}>
          Submit
        </Button>

        {csvData.length > 0 && (
          <div style={{ marginTop: "20px" }}>
            <h5>Uploaded School CSV Sheet Preview</h5>
            <Table
              columns={columns}
              dataSource={csvData}
              rowKey={(record, index) => index}
              scroll={{ x: 400 }}
            />
          </div>
        )}

        <Divider />
      </div>
    </div>
  );
};

export default AddbulkSchool;
